// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  width: 100%;
  overflow-x: auto;
  /* Enables horizontal scrolling */
  margin: 0 auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background-color: #f4f4f4;
}

th,
td {
  padding: 12px;
  text-align: left;
  /* border: 1px solid #ddd; */
}

@media (max-width: 768px) {

  th,
  td {
    font-size: 14px;
    /* Adjust font size for smaller screens */
  }
}



:root {
  --bs-font-sans-serif: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
}


/* === Integrations page micro-interactions (scoped) === */
.integrations-scope .integration-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, .06);
  transition: transform .16s ease, box-shadow .16s ease;
  background: #fff;
}

.integrations-scope .integration-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(16, 24, 40, .12);
}

.integrations-scope .integration-card .badge.connected {
  background-color: #E6F4EA;
  /* green-50 */
  color: #10793F;
  /* green-700 */
  border: 1px solid #BDE7CB;
  /* green-200 */
  font-weight: 500;
}

.integrations-scope .integration-card .badge.category {
  background-color: #F3F4F6;
  /* gray-100 */
  color: #374151;
  /* gray-700 */
  border: 1px solid #E5E7EB;
  /* gray-200 */
  font-weight: 500;
}

.integrations-scope .form-control:focus,
.integrations-scope .form-select:focus {
  border-color: #9CA3AF;
  /* gray-400 */
  box-shadow: 0 0 0 .15rem rgba(156, 163, 175, .35);
}

.integrations-scope .btn-outline-secondary:hover {
  border-color: #9CA3AF;
  background-color: #F9FAFB
}

.integrations-scope .btn-outline-danger:hover {
  border-color: #FCA5A5;
  background-color: #FEF2F2
}



/* base (same as before, trimmed to only diffs/important bits) */

.int-wrap {
  padding: 24px 28px 48px;
  min-height: 100%;
  color: #0f172a;
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial
}

@media (max-width: 767.98px) {
  .custom-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    max-width: 100% !important;
  }

  .page-content {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-top: 20px;
  }
}


/* Mobile: stack, full-width search & dropdown */
@media (max-width: 640px) {
  .int-wrap {
    color: #0f172a;
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial
  }
}


.int-title {
  margin: 0;
  font-size: 28px;
  font-family: var(--bs-font-sans-serif);
  color: #101828;
}

.int-subtitle {
  margin: 4px 0 0;
  color: #6b7280;
  word-spacing: 1px;
}

/* Toolbar container */
.int-toolbar {
  margin: 23px 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 10px;
  height: 72px;
  /* a little slimmer */
  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;
  flex-wrap: wrap;
  /* allow wrapping on small screens */
}

/* Search pill */
.int-search {
  width: 300px;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  background: #f5f6fa;
  border: 1px solid #c9ced6;
  border-radius: 10px;
}

.int-search-icon {
  font-size: 16px;
  opacity: .65;
}

.int-search input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #111827;
}

/* Dropdown trigger -> same soft pill; WIDER like your image */
.int-dropdown {
  position: relative;
}

.int-dropdown-trigger {
  min-width: 170px;
  /* wider length */
  height: 40px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f5f6fa;
  border: 1px solid #c9ced6;
  border-radius: 10px;
  cursor: pointer;
}

.int-dropdown-trigger:hover {
  border-color: #b3b9c3;
}

.int-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 20;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  min-width: 220px;
  /* list is wider, too */
  box-shadow: 0 16px 24px rgba(16, 24, 40, .14), 0 2px 8px rgba(16, 24, 40, .08);
  padding: 6px;
}

.int-dropdown-item {
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
}

.int-dropdown-item:hover {
  background: #f3f4f6;
}

.int-dropdown-item.is-active {
  background: #eef2ff;
  color: #4338ca;
}

/* Connected chip — solid blue like screenshot */
.int-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #c9ced6;
  background: #f5f6fa;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all .15s ease;
}

.int-chip-icon {
  font-size: 16px;
  line-height: 1;
}

.int-chip-on {
  background: #1d4ed8;
  /* blue fill */
  border-color: #1d4ed8;
  color: #fff;
  /* white text + icon */
}


.int-chip-on:hover {
  background: #1d4ed8;
  /* blue fill */
  border-color: #1d4ed8;
  color: #fff;
  /* white text + icon */
}

/* ---------- Responsive ---------- */
/* Tablet: spread controls, search wider */
@media (max-width: 1024px) {
  .int-toolbar {
    /* justify-content: space-between; */
    height: auto;
  }

  .int-search {
    width: 100%;
  }
}

/* Mobile: stack, full-width search & dropdown */
@media (max-width: 640px) {
  .int-toolbar {
    padding: 8px;
    gap: 8px;
  }

  .int-search {
    width: 100%;
  }

  .int-dropdown-trigger {
    width: 100%;
    min-width: 0;
  }

  .int-chip {
    width: 100%;
    justify-content: center;
  }
}


.int-dropdown {
  position: relative
}

.int-dropdown-trigger {
  height: 40px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer
}

.int-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 24px rgba(16, 24, 40, .14), 0 2px 8px rgba(16, 24, 40, .08);
  min-width: 180px;
  padding: 6px;
  z-index: 20
}

.int-dropdown-item {
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px
}

.int-dropdown-item:hover {
  background: #f3f4f6
}

.int-dropdown-item.is-active {
  background: #eef2ff;
  color: #4338ca
}

/* .int-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer
} */

.int-chip-dot {
  width: 8px;
  height: 8px;
  border-radius: 13px;
  background: #10b981
}



.int-section-heading {
  margin: 6px 2px 12px;
  font-size: 16px;
  color: #475569
}

.int-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* default = big screens = 4 cards */
  gap: 16px;
}

/* Laptop screens */
@media (min-width: 1024px) and (max-width: 1600px) {
  .int-grid {
    grid-template-columns: repeat(3, 1fr);
    /* 3 per row on laptops */
  }
}

/* Tablets */
@media (max-width: 1024px) {
  .int-grid {
    grid-template-columns: repeat(2, 1fr);
    /* 2 per row on tablets */
  }
}

/* Mobile */
@media (max-width: 640px) {
  .int-grid {
    grid-template-columns: 1fr;
    /* 1 per row on mobile */
  }
}



.int-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;
  display: flex;
  flex-direction: column;
  padding: 14px 14px 12px;
  transition: box-shadow .15s ease, transform .15s ease, border-color .15s ease
}

.int-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;
  border-color: #dbeafe
}

.int-card-muted {
  opacity: .6
}

.int-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px
}

.int-icon {
  width: 54px;
  height: 54px;
  /* border-radius: 12px;
  background: #f7f9fc;
  border: 1px solid #e7edf4; */
  display: grid;
  place-items: center;
}

.int-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  border: 1px solid transparent;
}

.int-badge-success {
  background: #E9FFF0;
  /* soft green fill */
  border-color: #B5ECC8;
  /* mint border */
  color: #0E7A44;
  /* deep green text */
}

.int-badge-success .bi {
  font-size: 14px;
  line-height: 1;
}

.int-card-title {
  font-weight: 400;
  font-family: var(--bs-font-sans-serif);
  font-size: 1rem;
  color: #101828;
  line-height: 1.5;
}

.int-card-desc {
  color: #4a5565;
  margin-top: 4px;
  margin-bottom: .25rem;
  font-size: 0.875rem;
  line-height: 1.4285714285714286;
  min-height: 34px;
}

/* Base for all three pills (applied per-class below so you don't change JS) */
.int-pill-pay,
.int-pill-acc,
.int-pill-mkt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  /* small pill height like ref */
  padding: 0 12px;
  /* narrow sides */
  border-radius: 9999px;
  /* fully rounded */
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  border: 1px solid;
  /* crisp 1px outline */
  white-space: nowrap;
  /* no wrap */
}

/* Payment (purple) */
.int-pill-pay {
  color: #8200db;
  /* text */
  background-color: #faf5ff;
  /* very light purple fill */
  border-color: #e9d4ff;
  border: 2px solid #e9d4ff;
  /* light purple border */
}

/* Accounting (green) */
.int-pill-acc {
  color: #008236;
  /* text */
  background-color: #ECFDF5;
  /* very light green fill */
  border-color: #f0fdf4;
  border: 2px solid #f0fdf4;
}

/* Marketing (orange) */
.int-pill-mkt {
  color: #EA580C;
  /* text */
  background-color: #FFF7ED;
  /* very light orange fill */
  border-color: #FED7AA;
  /* light orange border */
}


.int-card-actions {
  margin-top: 12px;
  display: flex
}

.int-btn {
  height: 38px;
  padding: 0 14px;
  border-radius: 10px;
  /* border: 1px solid #e5e7eb; */
  /* background: #fff; */
  cursor: pointer;
  transition: all .15s ease
}


.int-btn-primary {
  background: #1d4ed8;
  color: #fff;
  border-color: #1d4ed8
}

.int-btn-primary:hover {
  background: #1e40af;
  border-color: #1e40af
}

.int-btn-danger {
  background: #ef4444;
  color: #fff;
  border-color: #ef4444
}

.int-btn-ghost-danger {
  background: #fff;
  color: #c10007;
  border-color: #ff6467
}

.int-btn-ghost-danger:hover {
  background: #fef2f2;
  color: #030213;
  border-color: #c10007;
}

.int-spacer {
  flex: 1 1
}

/* Modal shell */
.int-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, .45);
  display: grid;
  place-items: center;
  z-index: 50
}

.int-modal {
  width: 500px;
  max-width: calc(100vw - 32px);
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 24px 48px rgba(16, 24, 40, .18);
  position: relative;
  left: 7.85vw;
}

@media (max-width: 640px) {
  .int-modal {
    width: 516px;
    max-width: calc(118vw - 32px);
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 24px 48px rgba(16, 24, 40, .18);
    position: relative;
    left: -0.15vw;
  }
}

.int-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #eef2f7
}

.int-modal-title {
  font-weight: 700;
  font-size: 16px
}

.int-modal-x {
  border: 0;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
  opacity: .7
}

.int-icon-img {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  /* or 6px for rounded corners */
  object-fit: cover;
}


.int-modal-body {
  padding: 0 18px 16px
}

.int-modal-scroll {
  /* max-height: min(70vh, 560px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 0; */
  /* -ms-overflow-style: none;
  scrollbar-width: none; */
  /* Firefox */
}

.int-modal-scroll {
  max-height: min(70vh, 560px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 0;

  /* Firefox */
  scrollbar-width: thin;
  /* makes it slimmer */
  scrollbar-color: #cbd5e1 transparent;
  /* thumb | track */
}

/* Chrome/Edge/Safari */
.int-modal-scroll::-webkit-scrollbar {
  width: 6px;
  /* <-- make thinner (try 4–8px) */
  height: 6px;
  /* for horizontal if any */
}

.int-modal-scroll::-webkit-scrollbar-track {
  background: transparent;
  margin: 8px 0;
  /* top/bottom spacing inside track */
}

.int-modal-scroll::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  /* slate-300 */
  border-radius: 8px;
  border: 2px solid transparent;
  /* creates a slimmer thumb look */
  background-clip: content-box;
}

.int-modal-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
  /* slate-400 on hover */
}


/* Chrome/Safari/WebKit */
/* .int-modal-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
} */

/* form controls */
.int-field {
  display: block;
  margin-bottom: 14px
}

.int-field-label {
  display: block;
  margin: 0 0 6px;
  font-size: 13px;
  color: #374151;
  font-weight: 600
}

.int-req {
  color: #ef4444
}

.int-input {
  width: 100%;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 8px 12px;
  outline: none
}

.int-input:focus {
  border-color: #a5b4fc;
  box-shadow: 0 0 0 3px #e0e7ff
}

/* rows */
.int-row-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px
}

/* footer */
.int-modal-footer {
  display: flex;
  gap: 10px;
}

@media (max-width: 640px) {
  .int-modal-footer {
    flex-direction: column;
    align-items: stretch;
    /* full width buttons */
  }

  .int-modal-footer .int-btn {
    width: 100%;
  }
}

/* Backdrop that covers the whole screen (and the parent modal) */
.int-nested {
  position: fixed;
  /* sit above everything */
  inset: 0;
  background: rgba(17, 24, 39, 0.5);
  /* dark scrim */
  z-index: 9999;
  /* very high so it's on top */
  display: grid;
  place-items: center;
  padding: 20px;
  /* avoid edges on small screens */
}

/* Dialog box */
.int-nested-modal {
  width: 520px;
  max-width: 100%;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 24px 48px rgba(16, 24, 40, .18), 0 8px 16px rgba(16, 24, 40, .1);
  padding: 18px 20px 16px;
  animation: nestedPop .12s ease-out;
}

@keyframes nestedPop {
  from {
    transform: translateY(4px) scale(.98);
    opacity: .9;
  }

  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

/* Title row with alert icon */
.int-nested-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.int-nested-icon {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #FEF2F2;
  /* soft red bg */
  color: #DC2626;
  /* red icon */
  display: grid;
  place-items: center;
  flex: 0 0 28px;
}

.int-nested-icon .bi {
  font-size: 16px;
  line-height: 1;
}

.int-nested-title {
  font-weight: 700;
  font-size: 16px;
  color: #111827;
}

/* Message */
.int-nested-msg {
  margin: 8px 0 16px;
  color: #4B5563;
  /* gray-600 */
  line-height: 1.45;
  font-size: 14px;
}

.int-red {
  color: #DC2626;
}

/* Actions */
.int-nested-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Buttons */
.int-btn {
  height: 36px;
  min-width: 104px;
  padding: 0 14px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  /* border: 1px solid transparent; */
  transition: background .15s ease, border-color .15s ease, color .15s ease;
}

/* Gray/neutral button */
.int-btn-plain {
  background: #fff;
  color: #374151;
  border-color: #D1D5DB;
}

.int-btn-plain:hover {
  background: #F9FAFB;
}

/* Red danger button */
.int-btn-danger {
  background: #DC2626;
  color: #fff;
  border-color: #DC2626;
}

.int-btn-danger:hover {
  background: #B91C1C;
  border-color: #B91C1C;
}


.danger-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  left: 238px;
}

.danger-modal {
  background: #fff;
  border-radius: 12px;
  padding: 24px 28px;
  width: 497px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.2s ease-out;
}

.danger-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.danger-icon {
  color: #dc2626;
  /* red */
  font-size: 24px;
  flex-shrink: 0;
}

.danger-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.danger-msg {
  font-size: 14px;
  color: #374151;
  margin: 0 0 8px;
  line-height: 1.5;
}

.danger-undo {
  font-size: 14px;
  color: #dc2626;
  font-weight: 500;
  margin-bottom: 20px;
}

.danger-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-cancel:hover {
  background: #f3f4f6;
}

.btn-danger {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: #dc2626;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-danger:hover {
  background: #b91c1c;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}


@media (max-width: 640px) {
  .danger-overlay {
    left: 0;
  }

  .danger-overlay {
    width: 100%;
  }
}

/* nested danger popup (inside modal) */
.int-nested {
  position: absolute;
  inset: 0;
  /* background:rgba(15,23,42,.45); */
  display: grid;
  place-items: center;
  border-radius: 16px
}

.int-nested-modal {
  /* max-width: calc(100% - 40px); */
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 18px 36px rgba(16, 24, 40, .2);
  padding: 56px 19px
}

.int-nested-title {
  font-weight: 700;
  margin-bottom: 8px
}

.int-nested-msg {
  color: #475569
}

.int-red {
  color: #ef4444
}

.int-nested-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 14px
}

@media (max-width:720px) {
  .int-row-3 {
    grid-template-columns: 1fr
  }
}


.custom-modal .modal-header {
  justify-content: center;
  /* centers the title */
  text-align: center;
  position: relative;
}

.custom-modal .modal-title {
  margin: 0 auto;
  font-weight: 600;
  font-size: 18px;
}

.custom-modal .modal-close {
  display: none !important;
  /* hide close icon */
}

.int-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  /* light gray border */
  border-radius: 10px;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  /* gray-700 */
  cursor: pointer;
  transition: all 0.2s ease;
}

.int-btn-ghost:hover {
  background: #f9fafb;
}

.int-btn-ghost i {
  font-size: 16px;
  color: #060606;
  /* muted gray icon */
}

/* Ensure dropdown items fill full width */
.ui-select option {
  width: 100%;
  padding: 10px 12px;
  background: #fff;
  border: none;
  cursor: pointer;
}

/* Hover covers full width */
.ui-select option:hover {
  background-color: #f3f4f6;
  /* light gray like your screenshot */
}

/* Active/selected look */
.ui-select option:checked {
  background-color: #eef2ff;
  /* light blue/purple */
  color: #4338ca;
  /* text color */
}`, "",{"version":3,"sources":["webpack://./src/pages/signage/SignageIntegrations.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE;;IAEE,eAAe;IACf,yCAAyC;EAC3C;AACF;;;;AAIA;EACE,6EAA6E;AAC/E;;;AAGA,0DAA0D;AAC1D;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;;;AAIA,gEAAgE;;AAEhE;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;;AAGA,gDAAgD;AAChD;EACE;IACE,cAAc;IACd;EACF;AACF;;;AAGA;EACE,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,6DAA6D;EAC7D,eAAe;EACf,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8EAA8E;EAC9E,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC,0CAA0C;AAC1C;EACE;IACE,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;;AAGA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8EAA8E;EAC9E,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB;AACF;;;;AAIA;EACE,oBAAoB;EACpB,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE;IACE,qCAAqC;IACrC,yBAAyB;EAC3B;AACF;;AAEA,YAAY;AACZ;EACE;IACE,qCAAqC;IACrC,yBAAyB;EAC3B;AACF;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;AACF;;;;AAIA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB;AACF;;AAEA;EACE,2BAA2B;EAC3B,6DAA6D;EAC7D;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;8BAE4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;AAC1B;;;AAGA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf;AACF;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,6CAA6C;IAC7C,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;;;AAGA;EACE;AACF;;AAEA;EACE;;;oBAGkB;EAClB;0BACwB;EACxB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,iCAAiC;EACjC,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;;AAGA,yBAAyB;AACzB;;;GAGG;;AAEH,kBAAkB;AAClB;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,kCAAkC;EAClC;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iEAAiE;AACjE;EACE,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8EAA8E;EAC9E,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,yEAAyE;AAC3E;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;EACE;IACE,OAAO;EACT;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT;AACF;;AAEA;EACE;IACE;EACF;AACF;;;AAGA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".table-container {\n  width: 100%;\n  overflow-x: auto;\n  /* Enables horizontal scrolling */\n  margin: 0 auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nthead {\n  background-color: #f4f4f4;\n}\n\nth,\ntd {\n  padding: 12px;\n  text-align: left;\n  /* border: 1px solid #ddd; */\n}\n\n@media (max-width: 768px) {\n\n  th,\n  td {\n    font-size: 14px;\n    /* Adjust font size for smaller screens */\n  }\n}\n\n\n\n:root {\n  --bs-font-sans-serif: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n\n/* === Integrations page micro-interactions (scoped) === */\n.integrations-scope .integration-card {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(16, 24, 40, .06);\n  transition: transform .16s ease, box-shadow .16s ease;\n  background: #fff;\n}\n\n.integrations-scope .integration-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 18px rgba(16, 24, 40, .12);\n}\n\n.integrations-scope .integration-card .badge.connected {\n  background-color: #E6F4EA;\n  /* green-50 */\n  color: #10793F;\n  /* green-700 */\n  border: 1px solid #BDE7CB;\n  /* green-200 */\n  font-weight: 500;\n}\n\n.integrations-scope .integration-card .badge.category {\n  background-color: #F3F4F6;\n  /* gray-100 */\n  color: #374151;\n  /* gray-700 */\n  border: 1px solid #E5E7EB;\n  /* gray-200 */\n  font-weight: 500;\n}\n\n.integrations-scope .form-control:focus,\n.integrations-scope .form-select:focus {\n  border-color: #9CA3AF;\n  /* gray-400 */\n  box-shadow: 0 0 0 .15rem rgba(156, 163, 175, .35);\n}\n\n.integrations-scope .btn-outline-secondary:hover {\n  border-color: #9CA3AF;\n  background-color: #F9FAFB\n}\n\n.integrations-scope .btn-outline-danger:hover {\n  border-color: #FCA5A5;\n  background-color: #FEF2F2\n}\n\n\n\n/* base (same as before, trimmed to only diffs/important bits) */\n\n.int-wrap {\n  padding: 24px 28px 48px;\n  min-height: 100%;\n  color: #0f172a;\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial\n}\n\n@media (max-width: 767.98px) {\n  .custom-container {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    max-width: 100% !important;\n  }\n\n  .page-content {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    margin-top: 20px;\n  }\n}\n\n\n/* Mobile: stack, full-width search & dropdown */\n@media (max-width: 640px) {\n  .int-wrap {\n    color: #0f172a;\n    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial\n  }\n}\n\n\n.int-title {\n  margin: 0;\n  font-size: 28px;\n  font-family: var(--bs-font-sans-serif);\n  color: #101828;\n}\n\n.int-subtitle {\n  margin: 4px 0 0;\n  color: #6b7280;\n  word-spacing: 1px;\n}\n\n/* Toolbar container */\n.int-toolbar {\n  margin: 23px 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  width: 100%;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 10px;\n  height: 72px;\n  /* a little slimmer */\n  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;\n  flex-wrap: wrap;\n  /* allow wrapping on small screens */\n}\n\n/* Search pill */\n.int-search {\n  width: 300px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 10px;\n  background: #f5f6fa;\n  border: 1px solid #c9ced6;\n  border-radius: 10px;\n}\n\n.int-search-icon {\n  font-size: 16px;\n  opacity: .65;\n}\n\n.int-search input {\n  width: 100%;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font-size: 14px;\n  color: #111827;\n}\n\n/* Dropdown trigger -> same soft pill; WIDER like your image */\n.int-dropdown {\n  position: relative;\n}\n\n.int-dropdown-trigger {\n  min-width: 170px;\n  /* wider length */\n  height: 40px;\n  padding: 0 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f5f6fa;\n  border: 1px solid #c9ced6;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.int-dropdown-trigger:hover {\n  border-color: #b3b9c3;\n}\n\n.int-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 20;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  min-width: 220px;\n  /* list is wider, too */\n  box-shadow: 0 16px 24px rgba(16, 24, 40, .14), 0 2px 8px rgba(16, 24, 40, .08);\n  padding: 6px;\n}\n\n.int-dropdown-item {\n  width: 100%;\n  text-align: left;\n  border: 0;\n  background: transparent;\n  border-radius: 8px;\n  padding: 10px 12px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.int-dropdown-item:hover {\n  background: #f3f4f6;\n}\n\n.int-dropdown-item.is-active {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n/* Connected chip — solid blue like screenshot */\n.int-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid #c9ced6;\n  background: #f5f6fa;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all .15s ease;\n}\n\n.int-chip-icon {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.int-chip-on {\n  background: #1d4ed8;\n  /* blue fill */\n  border-color: #1d4ed8;\n  color: #fff;\n  /* white text + icon */\n}\n\n\n.int-chip-on:hover {\n  background: #1d4ed8;\n  /* blue fill */\n  border-color: #1d4ed8;\n  color: #fff;\n  /* white text + icon */\n}\n\n/* ---------- Responsive ---------- */\n/* Tablet: spread controls, search wider */\n@media (max-width: 1024px) {\n  .int-toolbar {\n    /* justify-content: space-between; */\n    height: auto;\n  }\n\n  .int-search {\n    width: 100%;\n  }\n}\n\n/* Mobile: stack, full-width search & dropdown */\n@media (max-width: 640px) {\n  .int-toolbar {\n    padding: 8px;\n    gap: 8px;\n  }\n\n  .int-search {\n    width: 100%;\n  }\n\n  .int-dropdown-trigger {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .int-chip {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n\n.int-dropdown {\n  position: relative\n}\n\n.int-dropdown-trigger {\n  height: 40px;\n  padding: 0 12px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  cursor: pointer\n}\n\n.int-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 24px rgba(16, 24, 40, .14), 0 2px 8px rgba(16, 24, 40, .08);\n  min-width: 180px;\n  padding: 6px;\n  z-index: 20\n}\n\n.int-dropdown-item {\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  padding: 10px 12px;\n  cursor: pointer;\n  font-size: 14px\n}\n\n.int-dropdown-item:hover {\n  background: #f3f4f6\n}\n\n.int-dropdown-item.is-active {\n  background: #eef2ff;\n  color: #4338ca\n}\n\n/* .int-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 999px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  cursor: pointer\n} */\n\n.int-chip-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 13px;\n  background: #10b981\n}\n\n\n\n.int-section-heading {\n  margin: 6px 2px 12px;\n  font-size: 16px;\n  color: #475569\n}\n\n.int-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  /* default = big screens = 4 cards */\n  gap: 16px;\n}\n\n/* Laptop screens */\n@media (min-width: 1024px) and (max-width: 1600px) {\n  .int-grid {\n    grid-template-columns: repeat(3, 1fr);\n    /* 3 per row on laptops */\n  }\n}\n\n/* Tablets */\n@media (max-width: 1024px) {\n  .int-grid {\n    grid-template-columns: repeat(2, 1fr);\n    /* 2 per row on tablets */\n  }\n}\n\n/* Mobile */\n@media (max-width: 640px) {\n  .int-grid {\n    grid-template-columns: 1fr;\n    /* 1 per row on mobile */\n  }\n}\n\n\n\n.int-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;\n  display: flex;\n  flex-direction: column;\n  padding: 14px 14px 12px;\n  transition: box-shadow .15s ease, transform .15s ease, border-color .15s ease\n}\n\n.int-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 6px 1px #0000001a, 0 2px 4px -1px #0000000f;\n  border-color: #dbeafe\n}\n\n.int-card-muted {\n  opacity: .6\n}\n\n.int-card-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px\n}\n\n.int-icon {\n  width: 54px;\n  height: 54px;\n  /* border-radius: 12px;\n  background: #f7f9fc;\n  border: 1px solid #e7edf4; */\n  display: grid;\n  place-items: center;\n}\n\n.int-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  border: 1px solid transparent;\n}\n\n.int-badge-success {\n  background: #E9FFF0;\n  /* soft green fill */\n  border-color: #B5ECC8;\n  /* mint border */\n  color: #0E7A44;\n  /* deep green text */\n}\n\n.int-badge-success .bi {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.int-card-title {\n  font-weight: 400;\n  font-family: var(--bs-font-sans-serif);\n  font-size: 1rem;\n  color: #101828;\n  line-height: 1.5;\n}\n\n.int-card-desc {\n  color: #4a5565;\n  margin-top: 4px;\n  margin-bottom: .25rem;\n  font-size: 0.875rem;\n  line-height: 1.4285714285714286;\n  min-height: 34px;\n}\n\n/* Base for all three pills (applied per-class below so you don't change JS) */\n.int-pill-pay,\n.int-pill-acc,\n.int-pill-mkt {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 26px;\n  /* small pill height like ref */\n  padding: 0 12px;\n  /* narrow sides */\n  border-radius: 9999px;\n  /* fully rounded */\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  border: 1px solid;\n  /* crisp 1px outline */\n  white-space: nowrap;\n  /* no wrap */\n}\n\n/* Payment (purple) */\n.int-pill-pay {\n  color: #8200db;\n  /* text */\n  background-color: #faf5ff;\n  /* very light purple fill */\n  border-color: #e9d4ff;\n  border: 2px solid #e9d4ff;\n  /* light purple border */\n}\n\n/* Accounting (green) */\n.int-pill-acc {\n  color: #008236;\n  /* text */\n  background-color: #ECFDF5;\n  /* very light green fill */\n  border-color: #f0fdf4;\n  border: 2px solid #f0fdf4;\n}\n\n/* Marketing (orange) */\n.int-pill-mkt {\n  color: #EA580C;\n  /* text */\n  background-color: #FFF7ED;\n  /* very light orange fill */\n  border-color: #FED7AA;\n  /* light orange border */\n}\n\n\n.int-card-actions {\n  margin-top: 12px;\n  display: flex\n}\n\n.int-btn {\n  height: 38px;\n  padding: 0 14px;\n  border-radius: 10px;\n  /* border: 1px solid #e5e7eb; */\n  /* background: #fff; */\n  cursor: pointer;\n  transition: all .15s ease\n}\n\n\n.int-btn-primary {\n  background: #1d4ed8;\n  color: #fff;\n  border-color: #1d4ed8\n}\n\n.int-btn-primary:hover {\n  background: #1e40af;\n  border-color: #1e40af\n}\n\n.int-btn-danger {\n  background: #ef4444;\n  color: #fff;\n  border-color: #ef4444\n}\n\n.int-btn-ghost-danger {\n  background: #fff;\n  color: #c10007;\n  border-color: #ff6467\n}\n\n.int-btn-ghost-danger:hover {\n  background: #fef2f2;\n  color: #030213;\n  border-color: #c10007;\n}\n\n.int-spacer {\n  flex: 1\n}\n\n/* Modal shell */\n.int-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, .45);\n  display: grid;\n  place-items: center;\n  z-index: 50\n}\n\n.int-modal {\n  width: 500px;\n  max-width: calc(100vw - 32px);\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 24px 48px rgba(16, 24, 40, .18);\n  position: relative;\n  left: 7.85vw;\n}\n\n@media (max-width: 640px) {\n  .int-modal {\n    width: 516px;\n    max-width: calc(118vw - 32px);\n    background: #fff;\n    border-radius: 16px;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 24px 48px rgba(16, 24, 40, .18);\n    position: relative;\n    left: -0.15vw;\n  }\n}\n\n.int-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 18px;\n  border-bottom: 1px solid #eef2f7\n}\n\n.int-modal-title {\n  font-weight: 700;\n  font-size: 16px\n}\n\n.int-modal-x {\n  border: 0;\n  background: transparent;\n  font-size: 18px;\n  cursor: pointer;\n  opacity: .7\n}\n\n.int-icon-img {\n  width: 46px;\n  height: 46px;\n  border-radius: 8px;\n  /* or 6px for rounded corners */\n  object-fit: cover;\n}\n\n\n.int-modal-body {\n  padding: 0 18px 16px\n}\n\n.int-modal-scroll {\n  /* max-height: min(70vh, 560px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 16px 0; */\n  /* -ms-overflow-style: none;\n  scrollbar-width: none; */\n  /* Firefox */\n}\n\n.int-modal-scroll {\n  max-height: min(70vh, 560px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 16px 0;\n\n  /* Firefox */\n  scrollbar-width: thin;\n  /* makes it slimmer */\n  scrollbar-color: #cbd5e1 transparent;\n  /* thumb | track */\n}\n\n/* Chrome/Edge/Safari */\n.int-modal-scroll::-webkit-scrollbar {\n  width: 6px;\n  /* <-- make thinner (try 4–8px) */\n  height: 6px;\n  /* for horizontal if any */\n}\n\n.int-modal-scroll::-webkit-scrollbar-track {\n  background: transparent;\n  margin: 8px 0;\n  /* top/bottom spacing inside track */\n}\n\n.int-modal-scroll::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  /* slate-300 */\n  border-radius: 8px;\n  border: 2px solid transparent;\n  /* creates a slimmer thumb look */\n  background-clip: content-box;\n}\n\n.int-modal-scroll::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8;\n  /* slate-400 on hover */\n}\n\n\n/* Chrome/Safari/WebKit */\n/* .int-modal-scroll::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n} */\n\n/* form controls */\n.int-field {\n  display: block;\n  margin-bottom: 14px\n}\n\n.int-field-label {\n  display: block;\n  margin: 0 0 6px;\n  font-size: 13px;\n  color: #374151;\n  font-weight: 600\n}\n\n.int-req {\n  color: #ef4444\n}\n\n.int-input {\n  width: 100%;\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb;\n  padding: 8px 12px;\n  outline: none\n}\n\n.int-input:focus {\n  border-color: #a5b4fc;\n  box-shadow: 0 0 0 3px #e0e7ff\n}\n\n/* rows */\n.int-row-3 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 12px\n}\n\n/* footer */\n.int-modal-footer {\n  display: flex;\n  gap: 10px;\n}\n\n@media (max-width: 640px) {\n  .int-modal-footer {\n    flex-direction: column;\n    align-items: stretch;\n    /* full width buttons */\n  }\n\n  .int-modal-footer .int-btn {\n    width: 100%;\n  }\n}\n\n/* Backdrop that covers the whole screen (and the parent modal) */\n.int-nested {\n  position: fixed;\n  /* sit above everything */\n  inset: 0;\n  background: rgba(17, 24, 39, 0.5);\n  /* dark scrim */\n  z-index: 9999;\n  /* very high so it's on top */\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  /* avoid edges on small screens */\n}\n\n/* Dialog box */\n.int-nested-modal {\n  width: 520px;\n  max-width: 100%;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  box-shadow: 0 24px 48px rgba(16, 24, 40, .18), 0 8px 16px rgba(16, 24, 40, .1);\n  padding: 18px 20px 16px;\n  animation: nestedPop .12s ease-out;\n}\n\n@keyframes nestedPop {\n  from {\n    transform: translateY(4px) scale(.98);\n    opacity: .9;\n  }\n\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n/* Title row with alert icon */\n.int-nested-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.int-nested-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  background: #FEF2F2;\n  /* soft red bg */\n  color: #DC2626;\n  /* red icon */\n  display: grid;\n  place-items: center;\n  flex: 0 0 28px;\n}\n\n.int-nested-icon .bi {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.int-nested-title {\n  font-weight: 700;\n  font-size: 16px;\n  color: #111827;\n}\n\n/* Message */\n.int-nested-msg {\n  margin: 8px 0 16px;\n  color: #4B5563;\n  /* gray-600 */\n  line-height: 1.45;\n  font-size: 14px;\n}\n\n.int-red {\n  color: #DC2626;\n}\n\n/* Actions */\n.int-nested-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n/* Buttons */\n.int-btn {\n  height: 36px;\n  min-width: 104px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  /* border: 1px solid transparent; */\n  transition: background .15s ease, border-color .15s ease, color .15s ease;\n}\n\n/* Gray/neutral button */\n.int-btn-plain {\n  background: #fff;\n  color: #374151;\n  border-color: #D1D5DB;\n}\n\n.int-btn-plain:hover {\n  background: #F9FAFB;\n}\n\n/* Red danger button */\n.int-btn-danger {\n  background: #DC2626;\n  color: #fff;\n  border-color: #DC2626;\n}\n\n.int-btn-danger:hover {\n  background: #B91C1C;\n  border-color: #B91C1C;\n}\n\n\n.danger-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n  left: 238px;\n}\n\n.danger-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px 28px;\n  width: 497px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.2s ease-out;\n}\n\n.danger-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.danger-icon {\n  color: #dc2626;\n  /* red */\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.danger-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.danger-msg {\n  font-size: 14px;\n  color: #374151;\n  margin: 0 0 8px;\n  line-height: 1.5;\n}\n\n.danger-undo {\n  font-size: 14px;\n  color: #dc2626;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\n.danger-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.btn-cancel {\n  padding: 8px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  color: #374151;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btn-cancel:hover {\n  background: #f3f4f6;\n}\n\n.btn-danger {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btn-danger:hover {\n  background: #b91c1c;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n@media (max-width: 640px) {\n  .danger-overlay {\n    left: 0;\n  }\n\n  .danger-overlay {\n    width: 100%;\n  }\n}\n\n/* nested danger popup (inside modal) */\n.int-nested {\n  position: absolute;\n  inset: 0;\n  /* background:rgba(15,23,42,.45); */\n  display: grid;\n  place-items: center;\n  border-radius: 16px\n}\n\n.int-nested-modal {\n  /* max-width: calc(100% - 40px); */\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 18px 36px rgba(16, 24, 40, .2);\n  padding: 56px 19px\n}\n\n.int-nested-title {\n  font-weight: 700;\n  margin-bottom: 8px\n}\n\n.int-nested-msg {\n  color: #475569\n}\n\n.int-red {\n  color: #ef4444\n}\n\n.int-nested-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 14px\n}\n\n@media (max-width:720px) {\n  .int-row-3 {\n    grid-template-columns: 1fr\n  }\n}\n\n\n.custom-modal .modal-header {\n  justify-content: center;\n  /* centers the title */\n  text-align: center;\n  position: relative;\n}\n\n.custom-modal .modal-title {\n  margin: 0 auto;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.custom-modal .modal-close {\n  display: none !important;\n  /* hide close icon */\n}\n\n.int-btn-ghost {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #d1d5db;\n  /* light gray border */\n  border-radius: 10px;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  /* gray-700 */\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.int-btn-ghost:hover {\n  background: #f9fafb;\n}\n\n.int-btn-ghost i {\n  font-size: 16px;\n  color: #060606;\n  /* muted gray icon */\n}\n\n/* Ensure dropdown items fill full width */\n.ui-select option {\n  width: 100%;\n  padding: 10px 12px;\n  background: #fff;\n  border: none;\n  cursor: pointer;\n}\n\n/* Hover covers full width */\n.ui-select option:hover {\n  background-color: #f3f4f6;\n  /* light gray like your screenshot */\n}\n\n/* Active/selected look */\n.ui-select option:checked {\n  background-color: #eef2ff;\n  /* light blue/purple */\n  color: #4338ca;\n  /* text color */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
